module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-3-zoom.eefa12e3.png";